import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../../../../unicomponents/CSS/tableStyles/SpreadSheetTable.module.css";

export default function SurveySettingTable({
  surveys,
  selectedSurvey,
  onRowClick,
  onSurveyChange,
  onSurveySave,
  onAddSurvey,
  onDeleteSurvey,
  newSurvey,
  onInputChange,
  getDisplaySurvey,
  isCreating,
  isUpdating,
  isDeleting,
}) {
  const { t } = useTranslation();

  const selectStyle = {
    width: "100%",
    padding: "5px",
    border: "1px solid #bdbdbd",
    backgroundColor: "#fff",
    fontSize: "12px",
  };

  const inputStyle = {
    width: "100%",
    padding: "5px",
    border: "1px solid #bdbdbd",
    backgroundColor: "#fff",
    fontSize: "12px",
  };

  const titleInputStyle = {
    width: "100%",
    padding: "5px",
    border: "1px solid #bdbdbd",
    backgroundColor: "#fff",
    fontSize: "12px",
    minWidth: "200px",
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.th}>{t("common.survey.surveyType")}</th>
            <th className={styles.th} style={{ minWidth: "200px" }}>
              {t("common.survey.surveyTitle")}
            </th>
            <th className={styles.th}>{t("common.survey.responseTarget")}</th>
            <th className={styles.th}>{t("common.survey.status")}</th>
            <th
              className={styles.th}
              title={t("common.survey.allowQuestionAdd")}
            >
              {t("common.survey.allowQuestionAdd")}
            </th>
            <th className={styles.th}>{t("common.survey.isAnonymous")}</th>
            <th className={styles.th} title={t("common.survey.deadline")}>
              {t("common.survey.deadline")}
            </th>
            {/* <th
              className={styles.th}
              title={t("common.survey.teacherEditable")}
            >
              {t("common.survey.teacherEditable")}
            </th>
            <th className={styles.th}>{t("common.survey.noResponseAction")}</th>
            <th className={styles.th}>{t("common.survey.includeTag")}</th> */}
            <th className={styles.th}>{t("common.survey.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {surveys.map((survey) => {
            const displaySurvey = getDisplaySurvey(survey);
            return (
              <tr
                key={survey.id}
                className={`${styles.tr} ${styles.clickableRow} ${
                  selectedSurvey?.id === survey.id ? styles.selectedRow : ""
                }`}
                onClick={() => onRowClick(survey)}
              >
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.survey_type}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(survey.id, "survey_type", e.target.value);
                    }}
                  >
                    <option value="bySubject">
                      {t("common.survey.bySubject")}
                    </option>
                    {/* <option value="byTerm">{t("common.survey.byTerm")}</option>
                    <option value="bySchoolYear">
                      {t("common.survey.bySchoolYear")}
                    </option> */}
                  </select>
                </td>
                <td className={styles.td}>
                  <input
                    type="text"
                    style={titleInputStyle}
                    value={displaySurvey.title}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(survey.id, "title", e.target.value);
                    }}
                  />
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.response_target}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "response_target",
                        e.target.value
                      );
                    }}
                  >
                    <option value="student">
                      {t("common.survey.student")}
                    </option>
                    {/* <option value="teacher">
                      {t("common.survey.teacher")}
                    </option>
                    <option value="parent">{t("common.survey.parent")}</option>
                    <option value="all">{t("common.survey.all")}</option> */}
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.status}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(survey.id, "status", e.target.value);
                    }}
                  >
                    <option value="respondable">
                      {t("common.survey.respondable")}
                    </option>
                    <option value="readable">
                      {t("common.survey.readable")}
                    </option>
                    <option value="no_access">
                      {t("common.survey.noAccess")}
                    </option>
                    <option value="inactive">
                      {t("common.survey.inactive")}
                    </option>
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.allow_question_add}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "allow_question_add",
                        e.target.value === "true"
                      );
                    }}
                  >
                    <option value="true">{t("common.survey.yes")}</option>
                    <option value="false">{t("common.survey.no")}</option>
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.is_anonymous}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "is_anonymous",
                        e.target.value === "true"
                      );
                    }}
                  >
                    <option value="true">{t("common.survey.yes")}</option>
                    <option value="false">{t("common.survey.no")}</option>
                  </select>
                </td>
                <td className={styles.td}>
                  <input
                    type="number"
                    style={{ ...inputStyle, width: "75%" }}
                    value={displaySurvey.deadline}
                    min="-364"
                    max="364"
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "deadline",
                        parseInt(e.target.value)
                      );
                    }}
                  />
                  {t("common.survey.days")}
                </td>
                {/* <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.teacher_editable}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "teacher_editable",
                        e.target.value === "true"
                      );
                    }}
                  >
                    <option value="true">{t("common.survey.possible")}</option>
                    <option value="false">
                      {t("common.survey.impossible")}
                    </option>
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.no_response_action}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "no_response_action",
                        e.target.value
                      );
                    }}
                  >
                    <option value="none">{t("common.survey.none")}</option>
                    <option value="notice">{t("common.survey.notice")}</option>
                    <option value="report_not_viewable">
                      {t("common.survey.reportNotViewable")}
                    </option>
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    style={selectStyle}
                    value={displaySurvey.include_tag}
                    onChange={(e) => {
                      e.stopPropagation();
                      onSurveyChange(
                        survey.id,
                        "include_tag",
                        e.target.value === "true"
                      );
                    }}
                  >
                    <option value="true">{t("common.survey.include")}</option>
                    <option value="false">
                      {t("common.survey.notInclude")}
                    </option>
                  </select>
                </td> */}
                <td className={styles.td} style={{ textAlign: "center" }}>
                  <button
                    style={{
                      backgroundColor: isUpdating ? "#6c757d" : "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "4px 8px",
                      fontSize: "12px",
                      margin: "0 4px 0 0",
                      cursor: isUpdating ? "not-allowed" : "pointer",
                    }}
                    disabled={isUpdating}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSurveySave(survey.id);
                    }}
                  >
                    {isUpdating
                      ? t("common.survey.saving")
                      : t("common.survey.save")}
                  </button>
                  <button
                    style={{
                      backgroundColor: isDeleting ? "#6c757d" : "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "4px 8px",
                      margin: "0",
                      fontSize: "12px",
                      cursor: isDeleting ? "not-allowed" : "pointer",
                    }}
                    disabled={isDeleting}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSurvey(survey.id);
                    }}
                  >
                    {isDeleting
                      ? t("common.survey.deleting")
                      : t("common.survey.delete")}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr
            style={{
              backgroundColor: "#f8f9fa",
              borderTop: "2px solid #dee2e6",
            }}
          >
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.survey_type}
                onChange={(e) => onInputChange("survey_type", e.target.value)}
              >
                <option value="bySubject">
                  {t("common.survey.bySubject")}
                </option>
                {/* <option value="byTerm">{t("common.survey.byTerm")}</option>
                <option value="bySchoolYear">
                  {t("common.survey.bySchoolYear")}
                </option> */}
              </select>
            </td>
            <td className={styles.td}>
              <input
                type="text"
                style={titleInputStyle}
                placeholder={t("common.survey.surveyTitle")}
                value={newSurvey.title}
                onChange={(e) => onInputChange("title", e.target.value)}
              />
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.response_target}
                onChange={(e) =>
                  onInputChange("response_target", e.target.value)
                }
              >
                <option value="student">{t("common.survey.student")}</option>
                {/* <option value="teacher">{t("common.survey.teacher")}</option>
                <option value="parent">{t("common.survey.parent")}</option>
                <option value="all">{t("common.survey.all")}</option> */}
              </select>
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.status}
                onChange={(e) => onInputChange("status", e.target.value)}
              >
                <option value="respondable">
                  {t("common.survey.respondable")}
                </option>
                <option value="readable">{t("common.survey.readable")}</option>
                <option value="no_access">{t("common.survey.noAccess")}</option>
                <option value="inactive">{t("common.survey.inactive")}</option>
              </select>
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.allow_question_add}
                onChange={(e) =>
                  onInputChange("allow_question_add", e.target.value === "true")
                }
              >
                <option value="true">{t("common.survey.yes")}</option>
                <option value="false">{t("common.survey.no")}</option>
              </select>
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.is_anonymous}
                onChange={(e) =>
                  onInputChange("is_anonymous", e.target.value === "true")
                }
              >
                <option value="true">{t("common.survey.yes")}</option>
                <option value="false">{t("common.survey.no")}</option>
              </select>
            </td>
            <td className={styles.td}>
              <input
                type="number"
                style={{ ...inputStyle, width: "75%" }}
                placeholder="0"
                value={newSurvey.deadline}
                min="-364"
                max="364"
                onChange={(e) =>
                  onInputChange("deadline", parseInt(e.target.value))
                }
              />
              {t("common.survey.days")}
            </td>
            {/* <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.teacher_editable}
                onChange={(e) =>
                  onInputChange("teacher_editable", e.target.value === "true")
                }
              >
                <option value="true">{t("common.survey.possible")}</option>
                <option value="false">{t("common.survey.impossible")}</option>
              </select>
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.no_response_action}
                onChange={(e) =>
                  onInputChange("no_response_action", e.target.value)
                }
              >
                <option value="none">{t("common.survey.none")}</option>
                <option value="notice">{t("common.survey.notice")}</option>
                <option value="report_not_viewable">
                  {t("common.survey.reportNotViewable")}
                </option>
              </select>
            </td>
            <td className={styles.td}>
              <select
                style={selectStyle}
                value={newSurvey.include_tag}
                onChange={(e) =>
                  onInputChange("include_tag", e.target.value === "true")
                }
              >
                <option value="true">{t("common.survey.include")}</option>
                <option value="false">{t("common.survey.notInclude")}</option>
              </select>
            </td> */}
            <td className={styles.td} style={{ textAlign: "center" }}>
              <button
                style={{
                  backgroundColor: isCreating ? "#6c757d" : "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  cursor: isCreating ? "not-allowed" : "pointer",
                  fontWeight: "bold",
                }}
                disabled={isCreating}
                onClick={onAddSurvey}
              >
                {isCreating
                  ? t("common.survey.adding")
                  : t("common.survey.add")}
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
